import {Box} from "@material-ui/core";
import {useTranslation} from "react-i18next";
import i18nNamespaces from "../../../../const/i18nNamespaces";
import AddLanguage from "../AddLanguage/AddLanguage";
import AddedLanguages from "../AddedLanguages/AddedLanguages";
import useStyles from './MedicLanguagesStyles';
import useTileStyles from "../../common/tileCommonStyles";

const MedicLanguages = () => {
    const classes = useStyles();
    const tileClasses = useTileStyles();
    const {t} = useTranslation(i18nNamespaces.MEDIC);

    return (
        <div className={tileClasses.root}>
            <h3 className={tileClasses.headerText}>
                {t('preferredLanguages')}
            </h3>
            <Box className={classes.addTagWrapper}>
                <AddLanguage />
            </Box>
            <Box className={classes.addedTagsWrapper}>
                <AddedLanguages />
            </Box>
        </div>
    )
}

export default MedicLanguages;
